module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/51129746f637c83656246221e5a5a10c.png";